import "regenerator-runtime/runtime";
import "./network/supabase-client/supabase-client";
import "./sentry";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { ReduxStore } from "./store/store.redux";
import "./i18n";
import "./style.css";
import "@styled-system/styles.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-toastify/dist/ReactToastify.css";
import "./routes"; // Some weird bundling errors occur if this is not imported in the root file

const container = document.getElementById("root");

if (!container) {
	throw new Error("No root element found");
}

// TODO: add strictmode (react-spring-bottom-sheet doesn't work with strictmode)
createRoot(container).render(
	<Provider store={ReduxStore}>
		<App />
	</Provider>,
);
